/* WARA 21 · Catálogo — mejoras de interacción (solo layout catalogo) */
(function(){
  /* --- Menú lateral: cerrar con X, fondo oscuro o tecla Esc --- */
  function closeNav(){
    var n = document.querySelector('[data-nav]'), t = document.querySelector('[data-nav-toggle]');
    if (n && t && n.classList.contains('is-open')) t.click();
  }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-nav-close]')) { e.preventDefault(); closeNav(); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeNav(); });

  /* --- Celular: deslizar la foto de la tarjeta cambia a la 2ª imagen --- */
  if (!window.matchMedia || !matchMedia('(hover: none), (pointer: coarse)').matches) return;
  var x0 = null, y0 = null, swiped = false;
  document.addEventListener('touchstart', function(e){
    var m = e.target.closest('.grid .card.has-alt .card__media');
    if (!m) { x0 = null; return; }
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; swiped = false;
  }, {passive: true});
  document.addEventListener('touchend', function(e){
    if (x0 === null) return;
    var m = e.target.closest('.grid .card.has-alt .card__media');
    if (!m) return;
    var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
    x0 = null;
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) {
      swiped = true;
      m.closest('.card').classList.toggle('is-alt', dx < 0);
    }
  }, {passive: true});
  document.addEventListener('click', function(e){
    if (swiped && e.target.closest('.grid .card__media')) { e.preventDefault(); swiped = false; }
  }, true);
})();

/* --- Fotos que pasan solas (portada y categorías) ---
   Las fotos extra se descargan recién justo antes de mostrarse,
   y cada carrusel solo rota mientras está en pantalla. */
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var roots = [].slice.call(document.querySelectorAll('[data-rotate]'));
  function hydrate(el){
    if (!el) return;
    var imgs = el.tagName === 'IMG' ? [el] : [].slice.call(el.querySelectorAll('img'));
    imgs.forEach(function(im){
      if (im.dataset.src && !im.getAttribute('src')) {
        if (im.dataset.srcset) im.srcset = im.dataset.srcset;
        im.src = im.dataset.src;
      } else if (im.loading === 'lazy') { im.loading = 'eager'; }
    });
  }
  roots.forEach(function(root){
    var slides = root.querySelectorAll('.r-slide'); if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-dot]'), i = 0, t = null, ms = +root.dataset.interval || 5000, visible = false;
    function go(n){
      slides[i].classList.remove('is-on'); if (dots[i]) dots[i].classList.remove('is-on');
      i = (n + slides.length) % slides.length;
      hydrate(slides[i]);
      slides[i].classList.add('is-on'); if (dots[i]) dots[i].classList.add('is-on');
      hydrate(slides[(i + 1) % slides.length]);
    }
    function stop(){ if (t) { clearInterval(t); t = null; } }
    function start(){ if (reduce || !visible || document.hidden) return; stop(); t = setInterval(function(){ go(i + 1); }, ms); }
    [].forEach.call(dots, function(d){ d.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(+d.dataset.dot); start(); }); });
    document.addEventListener('visibilitychange', function(){ if (document.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){
        es.forEach(function(e){
          visible = e.isIntersecting;
          if (visible) { hydrate(slides[(i + 1) % slides.length]); setTimeout(start, +root.dataset.delay || 0); } else stop();
        });
      }, { rootMargin: '200px 0px' }).observe(root);
    } else {
      visible = true; hydrate(slides[1]); setTimeout(start, +root.dataset.delay || 0);
    }
  });
})();
